module.exports = "https://cdn.hellotech.com/client-assets/printers_tablet_ef10bcb5f7da907e7208da6359b4c109.webp";